import { supabase } from './supabase'

export type FeedbackCategory = 'feedback' | 'bug' | 'feature' | 'other'

type CreateFeedbackInput = {
  category: FeedbackCategory
  message: string
  userId: string
  email?: string
  locale?: string
  meta?: Record<string, unknown>
}

export async function createFeedback(input: CreateFeedbackInput) {
  const payload = {
    name: null,
    email: input.email || '',
    topic_slug: `app-feedback-${input.category}`,
    message: input.message,
    locale: input.locale || 'en',
    user_id: input.userId,
    meta: input.meta || null
  }

  const { error } = await supabase.from('contact_messages').insert(payload)

  if (error) {
    throw error
  }
}
